import { Injectable } from '@angular/core';
import { BaseController } from '@app/common/modules/base/base.controller';
import { AtendimentoModel } from '@app/data/atendimento/models';
import { AuthService } from '@app/infra/auth/auth.service';
import { AtendimentoRepository } from '@data/atendimento/atendimento.repository';

@Injectable()
export class AtendimentoController extends BaseController<AtendimentoModel> {
  constructor(atendimentoRepository: AtendimentoRepository, private authService: AuthService) {
    super(atendimentoRepository);
  }
}
